import * as React from 'react';
import { SVGProps } from 'react';
const SvgPersonSettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.705 12.872a3.403 3.403 0 0 1 2.406-.997h4.167a3.403 3.403 0 0 1 3.402 3.403v1.389a.625.625 0 1 1-1.25 0v-1.39a2.152 2.152 0 0 0-2.152-2.152H6.11a2.153 2.153 0 0 0-2.153 2.153v1.389a.625.625 0 1 1-1.25 0v-1.39c0-.902.359-1.767.997-2.405ZM8.195 4.792a2.153 2.153 0 1 0 0 4.305 2.153 2.153 0 0 0 0-4.305ZM4.792 6.944a3.403 3.403 0 1 1 6.805 0 3.403 3.403 0 0 1-6.805 0ZM15.139 8.958a.764.764 0 1 0 0 1.528.764.764 0 0 0 0-1.528Zm-2.014.764a2.014 2.014 0 1 1 4.027 0 2.014 2.014 0 0 1-4.027 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.139 7.014c.345 0 .625.28.625.625v.694a.625.625 0 0 1-1.25 0V7.64c0-.345.28-.625.625-.625ZM15.139 10.486c.345 0 .625.28.625.625v.695a.625.625 0 0 1-1.25 0v-.695c0-.345.28-.625.625-.625ZM17.486 8.37c.172.298.07.68-.23.852l-.604.348a.625.625 0 1 1-.623-1.084l.604-.347a.625.625 0 0 1 .853.23ZM14.48 10.105c.171.3.068.682-.231.854l-.604.347a.625.625 0 1 1-.623-1.084l.604-.347a.625.625 0 0 1 .853.23ZM15.798 10.105a.625.625 0 0 1 .854-.23l.604.347a.625.625 0 1 1-.623 1.084l-.604-.347a.625.625 0 0 1-.23-.854ZM12.791 8.37a.625.625 0 0 1 .854-.231l.604.347a.625.625 0 1 1-.623 1.084l-.604-.348a.625.625 0 0 1-.23-.853Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPersonSettingsIcon;
